import { uid } from "uid";

export function generateUID(length: number) {
  return uid(length);
}

export function capitalizeFirstLetter(string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
